import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import { T } from "../utils";
import { FontLink, Spinner } from "../components/UI";

export default function QRCheckIn() {
  const params  = new URLSearchParams(window.location.search);
  const session = params.get("session") || "";
  const service = params.get("service") || "";
  const date    = params.get("date")    || "";

  const [step,    setStep]    = useState("loading"); // loading | confirm | done | error | nologin
  const [profile, setProfile] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!session) { setStep("error"); setMessage("Invalid QR code — no session ID."); return; }
    supabase.auth.getUser().then(async ({ data: { user } }) => {
      if (!user) { setStep("nologin"); return; }
      const { data } = await supabase.from("profiles").select("id,name,full_name,avatar_url").eq("user_id", user.id).single();
      if (!data) { setStep("error"); setMessage("Your profile was not found. Please contact your pastor."); return; }
      setProfile(data);
      setStep("confirm");
    });
  }, []);

  const checkIn = async () => {
    setStep("loading");
    try {
      await supabase.channel(`qr-checkin:${session}`).send({
        type: "broadcast",
        event: "checkin",
        payload: { profile_id: profile.id, name: profile.name || profile.full_name },
      });
      setStep("done");
    } catch (e) {
      setStep("error");
      setMessage("Check-in failed: " + e.message);
    }
  };

  const name = profile?.name || profile?.full_name || "";

  return (
    <div style={{ minHeight:"100vh", background:T.navy, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif", padding:24 }}>
      <FontLink/>
      <div style={{ width:"100%", maxWidth:380, background:"#fff", borderRadius:20, padding:32, boxShadow:"0 20px 60px rgba(0,0,0,0.3)", textAlign:"center" }}>
        <div style={{ fontSize:40, marginBottom:12 }}>✝</div>
        <div style={{ fontFamily:"'Playfair Display',serif", fontSize:22, fontWeight:700, color:T.navy, marginBottom:4 }}>CNOM / CCN</div>
        <div style={{ fontSize:13, color:T.grey500, marginBottom:28 }}>Attendance Check-In</div>

        {step === "loading" && (
          <Spinner label="Please wait..."/>
        )}

        {step === "nologin" && (
          <>
            <div style={{ fontSize:36, marginBottom:12 }}>🔒</div>
            <div style={{ fontSize:16, fontWeight:700, color:T.navy, marginBottom:8 }}>Please log in first</div>
            <div style={{ fontSize:13, color:T.grey600, marginBottom:24 }}>
              Open the CNOM app, log in, then scan this QR code again.
            </div>
            <a href="/" style={{ display:"block", padding:"14px 0", background:T.navy, color:"#fff", borderRadius:12, fontWeight:700, fontSize:15, textDecoration:"none" }}>
              Go to Login
            </a>
          </>
        )}

        {step === "confirm" && (
          <>
            <div style={{ fontSize:36, marginBottom:8 }}>📱</div>
            <div style={{ fontSize:15, color:T.grey600, marginBottom:4 }}>Checking in as</div>
            <div style={{ fontSize:22, fontWeight:700, color:T.navy, fontFamily:"'Playfair Display',serif", marginBottom:20 }}>{name}</div>
            <div style={{ background:T.cream, borderRadius:12, padding:"14px 18px", marginBottom:24, textAlign:"left" }}>
              <div style={{ fontSize:12, color:T.grey500, marginBottom:2 }}>Service</div>
              <div style={{ fontSize:15, fontWeight:700, color:T.navy }}>{service}</div>
              <div style={{ fontSize:12, color:T.grey500, marginTop:8, marginBottom:2 }}>Date</div>
              <div style={{ fontSize:14, color:T.grey700 }}>{date}</div>
            </div>
            <button onClick={checkIn}
              style={{ width:"100%", padding:"16px 0", background:T.navy, color:"#fff", border:"none", borderRadius:14, fontWeight:700, fontSize:16, cursor:"pointer", fontFamily:"inherit" }}>
              ✓ Check Me In
            </button>
          </>
        )}

        {step === "done" && (
          <>
            <div style={{ fontSize:56, marginBottom:12 }}>✅</div>
            <div style={{ fontSize:22, fontWeight:700, color:T.navy, fontFamily:"'Playfair Display',serif", marginBottom:8 }}>
              You're checked in!
            </div>
            <div style={{ fontSize:14, color:T.grey600, marginBottom:24 }}>
              Welcome, {name}. Your attendance has been recorded.
            </div>
            <a href="/" style={{ display:"block", padding:"14px 0", background:T.navy, color:"#fff", borderRadius:12, fontWeight:700, fontSize:15, textDecoration:"none" }}>
              Open App
            </a>
          </>
        )}

        {step === "error" && (
          <>
            <div style={{ fontSize:36, marginBottom:12 }}>⚠️</div>
            <div style={{ fontSize:16, fontWeight:700, color:T.red, marginBottom:8 }}>Something went wrong</div>
            <div style={{ fontSize:13, color:T.grey600, marginBottom:24 }}>{message}</div>
            <a href="/" style={{ display:"block", padding:"14px 0", background:T.navy, color:"#fff", borderRadius:12, fontWeight:700, fontSize:15, textDecoration:"none" }}>
              Go to App
            </a>
          </>
        )}
      </div>
    </div>
  );
}
